import {
	Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy,
	ChangeDetectorRef
} from '@angular/core';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { NetFacadeService } from 'netview';
import { IdentityService } from 'identity';

@Component({
	selector: 'share-manager',
	templateUrl: './share-manager.component.html',
	styleUrls: ['./share-manager.component.scss']
})
export class ShareManagerComponent implements OnInit, OnChanges, OnDestroy {

	public selectedNetwork: NetViewDto;

	constructor(private netFacadeService: NetFacadeService,
		private identityService: IdentityService) {

		this.selectedNetwork = null;
	}

	public get hasSelectedNetwork(): boolean {
		return !!this.selectedNetwork;
	}

	public get isObserver(): boolean {
		return this.identityService.isObserver;
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {

	}

	public ngOnDestroy(): void {

	}

	public get networks(): NetViewDto[] {
		return this.netFacadeService.networks;
	}

	public get hasNetworks(): boolean {
		return (!!this.netFacadeService.networks && this.netFacadeService.networks.length > 0);
	}

	public get hasSharedNetworks(): boolean {
		return (!!this.netFacadeService.targetShares && this.netFacadeService.targetShares.length > 0);
	}

	public selectNetwork(network: NetViewDto): void {
		this.selectedNetwork = network;
	}

	public get selectedNetworkGuid(): string {
		if (this.hasSelectedNetwork) {
			return this.selectedNetwork.Guid;
		}
		else {
			return "";
		}
	}

}
